import { useMutation } from '@tanstack/react-query'

import type { UpdateSteeringRangeRequest } from '@/features/resource/endpoints/resources'
import { updateSteeringRange } from '@/features/resource/endpoints/resources'

export function useUpdateSteeringRangeMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: ({ rangeId, data }: { rangeId: string; data: UpdateSteeringRangeRequest }) =>
      updateSteeringRange(resourceId, rangeId, data),
  })

  return {
    updateSteeringRange: mutateAsync,
    ...mutationResult,
  }
}
